import {logger} from '@/helpers/logger';

export const getCellDataMappedCols = (mapperObj, columns) => {
  let mappedCols = [];
  try {
    if (columns?.length > 0) {
      const cols = columns.map((col) => {
        const custom = mapperObj[col?.name_of_db_column];
        if (custom) {
          // If the mapper returns a function, treat as cellData; if object, spread all handlers
          if (typeof custom === 'function') {
            return {...col, cellData: custom};
          } else if (typeof custom === 'object') {
            return {...col, ...custom};
          }
        }
        return {...col};
      });
      mappedCols = cols;
    }
  } catch (err) {
    logger.error('Error: ', err?.message);
  }
  return mappedCols || columns;
};
